export default __webpack_public_path__ + "static/media/coinbase.a3a7d7fd.svg";